/**
 * [CRO] PLP card — variant image swap on swatch click + dynamic load-more support
 */
(function () {
  'use strict';

  function init() {
    const cards = document.querySelectorAll('product-card, .product-card');
    cards.forEach(initCard);
  }

  function initCard(card) {
    if (card.dataset.swatchSwapInit === 'true') return;
    card.dataset.swatchSwapInit = 'true';

    const swatches = card.querySelectorAll('.product-card__color-swatch');
    if (!swatches.length) return;

    const variantsScript = card.querySelector('[data-product-variants-json]');
    if (!variantsScript) return;

    let variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (e) {
      return;
    }
    if (!Array.isArray(variants) || variants.length === 0) return;

    swatches.forEach((swatch) => {
      const colorName = swatch.dataset.swatchName;
      if (!colorName) return;

      const matchedVariant = findVariantByColor(variants, colorName);
      if (!matchedVariant || !matchedVariant.featured_image) {
        swatch.classList.add('product-card__color-swatch--no-image');
        return;
      }

      swatch.classList.add('product-card__color-swatch--clickable');
      swatch.setAttribute('tabindex', '0');
      swatch.setAttribute('role', 'button');

      swatch.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        swapCardImage(card, matchedVariant);
        updateProductLink(card, matchedVariant);
        setSelectedState(card, swatch);
      });

      swatch.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          swatch.click();
        }
      });
    });
  }

  function findVariantByColor(variants, colorName) {
    return (
      variants.find((v) => v.available && matchesColor(v, colorName)) ||
      variants.find((v) => matchesColor(v, colorName))
    );
  }

  function matchesColor(variant, colorName) {
    return variant.option1 === colorName || variant.option2 === colorName || variant.option3 === colorName;
  }

  function swapCardImage(card, variant) {
    const img = variant.featured_image;
    if (!img) return;
    const rawUrl = typeof img === 'string' ? img : img.src || img.url;
    if (!rawUrl) return;
    const sizedUrl = rawUrl.replace(/(\.(jpe?g|png|webp|gif))(\?.*)?$/i, '_900x$1$3');

    // Try Release's existing variant-tagged images
    const taggedImages = card.querySelectorAll('.product-card__media img[data-product-images]');
    let usedExisting = false;
    if (taggedImages.length > 1) {
      taggedImages.forEach((el) => {
        const ids = (el.dataset.productImages || '').split(',');
        if (ids.includes(String(variant.id))) {
          el.classList.remove('hidden');
          usedExisting = true;
        } else {
          el.classList.add('hidden');
        }
      });
    }

    // If product card uses the new gallery (multi-image carousel), scroll to variant's image
    const galleryTrack = card.querySelector('[data-gallery-track]');
    if (galleryTrack && img.id) {
      const matchingSlide = galleryTrack.querySelector(`[data-media-id="${img.id}"]`);
      if (matchingSlide) {
        matchingSlide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        return;
      }
    }

    // Fallback: directly swap the main img src
    if (!usedExisting) {
      const mainImg =
        card.querySelector('.product-card__media img:not(.hover-img):not(.hidden)') ||
        card.querySelector('.product-card__media img:not(.hover-img)') ||
        card.querySelector('.product-card__media img');
      if (mainImg) {
        mainImg.src = sizedUrl;
        mainImg.removeAttribute('srcset');
      }
    }
  }

  function updateProductLink(card, variant) {
    card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
      try {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', variant.id);
        link.href = url.toString();
      } catch (e) {}
    });
  }

  function setSelectedState(card, clickedSwatch) {
    card.querySelectorAll('.product-card__color-swatch--selected').forEach((s) =>
      s.classList.remove('product-card__color-swatch--selected')
    );
    clickedSwatch.classList.add('product-card__color-swatch--selected');
  }

  // ---- Dynamic load-more support via MutationObserver ----
  function watchDynamicCards() {
    const observer = new MutationObserver((mutations) => {
      let needsInit = false;
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (
            node.matches?.('product-card, .product-card') ||
            node.querySelector?.('product-card, .product-card')
          ) {
            needsInit = true;
            break;
          }
        }
        if (needsInit) break;
      }
      if (needsInit) init();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      watchDynamicCards();
    });
  } else {
    init();
    watchDynamicCards();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();